var _circle, _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCypressio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    fill: "#ffffff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 323.384,
    x2: 56.936,
    y1: 12.396,
    y2: 577.503,
    gradientTransform: "translate(-.876 -.754) scale(.13472)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#69d3a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#2ab586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1cae7f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 992.991,
    x2: 568.87,
    y1: 483.702,
    y2: 758.304,
    gradientTransform: "translate(-.876 -.754) scale(.13472)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    stopColor: "#69d3a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69d3a7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 5.828,
    x2: 704.494,
    y1: 697.848,
    y2: 917.116,
    gradientTransform: "translate(-.876 -.754) scale(.13472)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#1cae7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#1ca379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#1c8568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#1b554d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#1b1e2e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.984 50.817c5.173 0 9.377 2.762 11.532 7.558l.162.378 8.676-2.95-.175-.445c-3.355-8.192-11.101-13.27-20.195-13.27-6.4 0-11.6 2.047-15.897 6.264-4.271 4.19-6.427 9.458-6.427 15.655 0 6.157 2.17 11.397 6.427 15.574 4.297 4.217 9.498 6.264 15.897 6.264 9.094 0 16.827-5.092 20.195-13.27l.175-.444-8.69-2.95-.148.39c-1.94 4.729-6.251 7.544-11.532 7.544-3.597 0-6.642-1.253-9.04-3.732-2.439-2.505-3.665-5.671-3.665-9.376 0-3.732 1.2-6.83 3.665-9.458 2.411-2.479 5.443-3.732 9.04-3.732z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m82.652 125.13-2.586-8.528c23.334-7.086 39.015-28.224 39.015-52.595 0-6.723-1.199-13.297-3.57-19.522l8.326-3.166A63.468 63.468 0 0 1 128 64.02c-.013 28.305-18.228 52.865-45.348 61.11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#69d3a7",
    d: "M116.67 47.894C109.543 24.641 88.378 9.026 63.993 9.026a56.039 56.039 0 0 0-9.861.876l-1.577-8.77A64.836 64.836 0 0 1 63.993.108c28.319 0 52.906 18.147 61.191 45.159z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M4.096 86.532C1.374 79.338 0 71.753 0 64.007 0 31 24.776 3.664 57.634.43l.876 8.865C30.232 12.085 8.905 35.607 8.905 64.006a54.82 54.82 0 0 0 3.516 19.387z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.33 42.896 81.79 85.63l-12.718 30.85 8.905 1.779 30.96-75.364h-9.62l-12.353 31.31-12.449-31.31z",
    className: "st0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m70.675 112.601-1.872 4.54c-.431 1.038-1.415 1.752-2.52 1.792-.767.027-1.522.054-2.303.054-24.452 0-46.224-16.369-52.946-39.81l-8.569 2.451c7.814 27.228 33.102 46.25 61.501 46.264h.014c.889 0 1.778-.013 2.667-.054 4.567-.188 8.65-3.058 10.4-7.302l2.534-6.156z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCypressio);
export default __webpack_public_path__ + "static/media/cypressio.5c459e91b705eb56189560cb22fc66a4.svg";
export { ForwardRef as ReactComponent };